import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@core/constants';
import {
  ICorrectedReasonDTO,
  IDocumentResponseDTO,
  IEditReasonDTO,
  ILetterLogAuditItem,
  IUpdateDocMetaDataDTO,
} from '@core/model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LetterLogService {
  constructor(
    private http: HttpClient,
    @Inject(API_URL) private apiUrl: string
  ) {}

  private get baseUrl(): string {
    return `${this.apiUrl}/api/LetterLog`;
  }

  getCorrectedReasons(): Observable<ICorrectedReasonDTO[]> {
    return this.http.get<ICorrectedReasonDTO[]>(
      `${this.baseUrl}/GetCorrectedReasons`
    );
  }

  getEditReasons(): Observable<IEditReasonDTO[]> {
    return this.http.get<IEditReasonDTO[]>(`${this.baseUrl}/GetEditReasons`);
  }

  updateLetter(
    letter: IUpdateDocMetaDataDTO
  ): Observable<IDocumentResponseDTO[]> {
    return this.http.post<IDocumentResponseDTO[]>(
      `${this.baseUrl}/UpdateLetter`,
      letter
    );
  }

  getLetterAudit(docMetaDataId: string): Observable<ILetterLogAuditItem[]> {
    return this.http.get<ILetterLogAuditItem[]>(`${this.baseUrl}/AuditByDocMetaDataId/${docMetaDataId}`);
  }
}
